// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

import Rails from "@rails/ujs";
import Turbolinks from "turbolinks";
import * as ActiveStorage from "@rails/activestorage";
import "channels";
import "../stylesheets/application.scss";

import { Dropzone } from "dropzone";
import "dropzone/dist/dropzone.css";

import passwordHide from "../images/password-hide.png";
import passwordShow from "../images/password-show.png";

window.Dropzone = Dropzone;

Rails.start();
//Turbolinks.start();
ActiveStorage.start();

function createPasswordIcon(src) {
  var img = document.createElement("img");
  img.src = src;
  img.style.marginLeft = "-30px";
  img.style.height = "1.2em";
  img.style.width = "1.2em";
  img.style.display = "inline";
  img.style.cursor = "pointer";

  return img;
}

// document.addEventListener("turbolinks:load", function() {
document.addEventListener("DOMContentLoaded", function () {
  // Refresh page when search input is clear
  document.querySelectorAll("input[type=search]").forEach(function (el) {
    el.addEventListener("search", function (ev) {
      if (ev.target.value.length === 0) {
        window.location = window.location.pathname;
      }
    });
  });

  // Password reveal feature
  document.querySelectorAll("input[type=password]").forEach(function (el) {
    if (el.after) {
      var img = createPasswordIcon(passwordHide);
      var isShow = false;

      img.onclick = function () {
        isShow = !isShow;

        if (isShow) {
          el.type = "text";
          img.src = passwordShow;
        } else {
          el.type = "password";
          img.src = passwordHide;
        }
      };

      var i = document.createElement("i");
      i.appendChild(img);
      el.after(i);
    }
  });

  // For Bulk create feature
  var uploadForm = document.querySelector("form#bulk-create-form");
  if (uploadForm) {
    var uploadForm = document.querySelector(".upload-form");
    var uploadProgress = document.querySelector(".upload-progress");
    var uploadErrors = document.querySelector(".upload-errors");

    var dropzone = new Dropzone("form#bulk-create-form", {
      init: function () {
        this.on("processing", function (file) {
          uploadForm.classList.add("hidden");
          uploadProgress.classList.remove("hidden");
          uploadErrors.classList.add("hidden");
        });

        this.on("complete", function (file) {
          uploadForm.classList.remove("hidden");
          uploadProgress.classList.add("hidden");

          if (file.status === "error") {
            uploadErrors.classList.remove("hidden");

            if (file.type !== "text/csv") {
              uploadErrors.querySelector("ul").innerHTML =
                "<li>Invalid file type</li>";
            }

            if (file.xhr.responseText) {
              var errors = file.xhr.responseText
                .split(",")
                .map(function (msg) {
                  return "<li>" + msg.replaceAll("\n", ", ") + "</li>";
                })
                .join("");

              uploadErrors.querySelector("ul").innerHTML = errors;
            }
            this.removeFile(file);
          } else {
            window.location = file.xhr.responseURL;
          }
        });

        this.on("uploadprogress", function (_file, progress, _bytesSent) {
          var bar = document.querySelector(".progress");
          bar.style.width = progress + "%";
        });
      },
      url: uploadForm.dataset.uploadUrl,
      headers: { Accept: "text/html" },
      acceptedFiles: "text/csv",
      disablePreviews: true,
    });
  }
});
